<template>
  <v-carousel 
    ref="carousel" 
    id="carousel" 
    :height="height"
    hide-delimiters 
    cycle
    interval="8000"
    :show-arrows="publicNewsList.length > 0"
  >
    <v-sheet color="primary">
      <template v-if="publicNewsList.length">
        <v-carousel-item
          v-for="(item,i) in publicNewsList"
          :key="i"
          :src="item.imageName ? $_file_getNewsPath(item.imageName) : ''"
        >
          <v-row v-if="item.type === 'image-cover'" class="mt-0 fill-height">
            <v-col offset="1" cols="7" class="news-overlay-sheet align text-left">
              <v-row class="fill-height" align="center" justify="center"  >
                <v-col>
                  <div class="news-overlay-content">
                    <h3 class="title white--text mb-1">
                      {{ item.title }}
                    </h3>
                    <h5 class="body-2" v-if="item.author">{{ item.author }}</h5>
                  </div>
                  <v-divider class="divider my-2"></v-divider>
                  <p class="body-1">
                    {{ item.description }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-row class="fill-height" align="center" justify="center">
            <v-col cols="12">
              <h1 class="text-xl-h3 text-lg-h4 text-center text--white">{{ $t('News.Slider.default') }}</h1>
            </v-col>
          </v-row>
        </v-carousel-item>
      </template>
    </v-sheet>
  </v-carousel>
</template>

<script>
import FileMixin from '@/mixins/FileMixin'
import { NewsRepository } from '@portal/api'
export default {
  name: 'NewsSlider',
  mixins: [FileMixin],
  props: {
    height: {type: String, required: false, default: '300px'},
    isPublic: {type: Boolean, required: false, default: false}
  },
  data: () => ({
    publicNewsList: [],
  }),
  async created () {
    this.publicNewsList = await NewsRepository.fetchAll({isActive: true, isPublic: this.isPublic})
  }
}
</script>

<style>
.news-overlay-sheet {
  background: rgba(0, 0, 0, 0.6);
  /* height: 100%; */
}

.divider {
  border-color: rgb(255, 255, 255)!important;
}
</style>